/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_FormularioProveedor as FormularioProveedor,
  rec_FormularioVehiculo as FormularioVehiculo,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_TablaFlota as TablaFlota,
  rec_api as api,
} from "../../runtime/index.jsx";
export function Flota() {
  let e = Go(),
    { confirmar: t } = Fo(),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)([]),
    [o, s] = (0, React.useState)(!0),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(null),
    [p, m] = (0, React.useState)(null),
    [h, g] = (0, React.useState)(``),
    [_, v] = (0, React.useState)(``),
    y = (0, React.useCallback)(async () => {
      s(!0);
      try {
        let [e, t] = await Promise.all([
          api(`/transporte/unidades`),
          api(`/transporte/proveedores`),
        ]);
        (r(e), a(t), l(``));
      } catch (e) {
        l(e.message);
      } finally {
        s(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    y();
  }, [y]);
  let b = (0, React.useMemo)(() => {
      let e = h.trim().toLowerCase();
      return e
        ? n.filter((t) =>
            [t.placa, t.tipo, t.descripcion]
              .filter(Boolean)
              .some((t) => t.toLowerCase().includes(e)),
          )
        : n;
    }, [n, h]),
    x = (0, React.useMemo)(() => {
      let e = _.trim().toLowerCase();
      return e
        ? i.filter((t) =>
            [t.nombre, t.ruc]
              .filter(Boolean)
              .some((t) => t.toLowerCase().includes(e)),
          )
        : i;
    }, [i, _]);
  async function S(n, r) {
    let i = n === `proveedor`,
      a = i ? r.nombre : r.placa,
      o = !r.activo;
    if (
      o ||
      (await t({
        titulo: o ? `Volver a usar` : `Dejar de usar`,
        mensaje: `${a} deja de aparecer al armar una orden. Las órdenes que ya pasaron no cambian.`,
        confirmarTexto: `Dejar de usar`,
      }))
    )
      try {
        (i
          ? await api(`/transporte/proveedores`, {
              method: `POST`,
              body: JSON.stringify({
                id: r.id,
                nombre: r.nombre,
                ruc: r.ruc,
                activo: o,
              }),
            })
          : await api(`/transporte/unidades`, {
              method: `POST`,
              body: JSON.stringify({
                id: r.id,
                placa: r.placa,
                descripcion: r.descripcion,
                tipo: r.tipo,
                asientos: r.asientos,
                activo: o,
              }),
            }),
          e.ok(o ? `${a} vuelve a estar disponible` : `${a} ya no se ofrece`),
          y());
      } catch (t) {
        e.error(t.message);
      }
  }
  return (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={c} onReintentar={y} />,
        <div
          className={`grid grid-cols-1 gap-4 lg:grid-cols-2`}
          children={[
            <TablaFlota
              titulo={`Proveedores`}
              descripcion={`Quiénes ponen las unidades.`}
              textoNuevo={`Nuevo proveedor`}
              onNuevo={() => m({})}
              busqueda={_}
              onBuscar={v}
              placeholderBusqueda={`Buscar por razón social o RUC`}
              columnas={[`Razón social`, `RUC`]}
              total={i.length}
              filas={x}
              cargando={o}
              textoVacio={`Todavía no hay proveedores.`}
              textoSinCoincidencias={`Ninguno coincide con lo que buscaste.`}
              nombreDe={(e) => e.nombre}
              celdas={(e) => [
                <span
                  key={`nombre`}
                  className={`block truncate text-(--text-h)`}
                  children={e.nombre}
                />,
                <span
                  key={`ruc`}
                  className={`hidden whitespace-nowrap text-(--text) sm:block`}
                  children={e.ruc || `—`}
                />,
              ]}
              onEditar={(e) =>
                m({
                  editar: e,
                })
              }
              onAlternar={(e) => S(`proveedor`, e)}
            />,
            <TablaFlota
              titulo={`Unidades`}
              descripcion={`Se eligen de esta lista al armar una orden, así la placa no se escribe a mano.`}
              textoNuevo={`Nueva unidad`}
              onNuevo={() => f({})}
              busqueda={h}
              onBuscar={g}
              placeholderBusqueda={`Buscar por placa, tipo o proveedor`}
              columnas={[`Placa`, `Tipo`, `Asientos`]}
              total={n.length}
              filas={b}
              cargando={o}
              textoVacio={`Todavía no hay unidades. Agregá al menos una para poder armar órdenes.`}
              textoSinCoincidencias={`Ninguna coincide con lo que buscaste.`}
              nombreDe={(e) => e.placa}
              celdas={(e) => [
                <span
                  key={`placa`}
                  className={`block truncate whitespace-nowrap text-(--text-h)`}
                  children={e.placa}
                />,
                <span
                  key={`tipo`}
                  className={`hidden truncate text-(--text) sm:block`}
                  children={e.tipo}
                />,
                <span
                  key={`asientos`}
                  className={`block whitespace-nowrap text-(--text)`}
                  children={e.asientos}
                />,
              ]}
              onEditar={(e) =>
                f({
                  editar: e,
                })
              }
              onAlternar={(e) => S(`unidad`, e)}
            />,
          ]}
        />,
        p && (
          <FormularioProveedor
            editar={p.editar}
            onClose={() => m(null)}
            onGuardado={() => {
              (m(null), e.ok(`Cambios guardados`), y());
            }}
          />
        ),
        u && (
          <FormularioVehiculo
            editar={u.editar}
            onClose={() => f(null)}
            onGuardado={() => {
              (f(null), e.ok(`Cambios guardados`), y());
            }}
          />
        ),
      ]}
    />
  );
}
